// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"dtOi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initGSAPFlairButtons", ()=>initGSAPFlairButtons);
var _gsap = require("gsap");
var _gsapDefault = parcelHelpers.interopDefault(_gsap);
class Button {
    constructor(buttonElement){
        this.block = buttonElement;
        this.init();
        this.initEvents();
    }
    init() {
        const el = (0, _gsapDefault.default).utils.selector(this.block);
        this.DOM = {
            button: this.block,
            flair: el('.button__flair')
        };
        this.xSet = (0, _gsapDefault.default).quickSetter(this.DOM.flair, 'xPercent');
        this.ySet = (0, _gsapDefault.default).quickSetter(this.DOM.flair, 'yPercent');
    }
    getXY(e) {
        const { left, top, width, height } = this.DOM.button.getBoundingClientRect();
        const xTransformer = (0, _gsapDefault.default).utils.pipe((0, _gsapDefault.default).utils.mapRange(0, width, 0, 100), (0, _gsapDefault.default).utils.clamp(0, 100));
        const yTransformer = (0, _gsapDefault.default).utils.pipe((0, _gsapDefault.default).utils.mapRange(0, height, 0, 100), (0, _gsapDefault.default).utils.clamp(0, 100));
        return {
            x: xTransformer(e.clientX - left),
            y: yTransformer(e.clientY - top)
        };
    }
    initEvents() {
        this.DOM.button.addEventListener('mouseenter', (e)=>{
            const { x, y } = this.getXY(e);
            this.xSet(x);
            this.ySet(y);
            (0, _gsapDefault.default).to(this.DOM.flair, {
                scale: 1,
                duration: 0.4,
                ease: 'power2.out'
            });
            this.block.classList.add('is-on-white');
        });
        this.DOM.button.addEventListener('mouseleave', (e)=>{
            const { x, y } = this.getXY(e);
            (0, _gsapDefault.default).killTweensOf(this.DOM.flair);
            (0, _gsapDefault.default).to(this.DOM.flair, {
                xPercent: x > 90 ? x + 20 : x < 10 ? x - 20 : x,
                yPercent: y > 90 ? y + 20 : y < 10 ? y - 20 : y,
                scale: 0,
                duration: 0.3,
                ease: 'power2.out'
            });
            this.block.classList.remove('is-on-white');
        });
        this.DOM.button.addEventListener('mousemove', (e)=>{
            const { x, y } = this.getXY(e);
            (0, _gsapDefault.default).to(this.DOM.flair, {
                xPercent: x,
                yPercent: y,
                duration: 0.4,
                ease: 'power2'
            });
        });
    }
}
function initGSAPFlairButtons() {
    const buttonElements = document.querySelectorAll('[data-block="button"]');
    buttonElements.forEach((buttonElement)=>new Button(buttonElement));
}
// auto-init
initGSAPFlairButtons();

},{"gsap":"kKW9v","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["dtOi1"], "dtOi1", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.3c37b58a.js.map
